<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="onClickCloseModal()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              class="pa-3"
              style="border-radius: 25px; height: auto;"
              color="secondary"
              @click="onClickSaveProduct()"
            >
              <v-icon class="black--text mr-2">
                mdi-check
              </v-icon>
              <span class="black--text">GUARDAR</span>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 md5>
            <v-card flat>
              <v-card-text>
                <v-form ref="productForm">
                  <v-layout align-center justify-center column fill-height>
                    <v-flex xs12 class="mt-5">
                      <h2>
                        Información del producto
                      </h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout align-center justify-center column fill-height>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <!-- <v-flex xs12 class="mt-2 pt-3 pl-3 pr-3">
                              <h3>Este producto es para incluir en facturas de:</h3>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-checkbox
                                v-model="productForm.invoice_type"
                                label="Venta"
                                color="success"
                                value="Venta"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-checkbox
                                v-model="productForm.invoice_type"
                                label="Gasto"
                                color="orange"
                                value="Gasto"
                              ></v-checkbox>
                            </v-flex>-->
                            <v-flex xs12 md6 class="pa-3">
                              <v-select
                                ref="type"
                                :rules="[rules.required]"
                                v-model="productForm.type"
                                :items="types"
                                label="Tipo"
                                item-value="value"
                                item-text="text"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="name"
                                v-model="productForm.name"
                                :rules="[rules.required]"
                                label="Nombre"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="price"
                                :rules="[rules.required]"
                                v-model="productForm.price"
                                label="Precio"
                                type="number"
                                step="0.1"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-select
                                ref="tax"
                                class="pr-2"
                                v-model="productForm.tax"
                                :items="taxes"
                                item-text="text"
                                item-value="value"
                                label="IVA"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 class="pa-3">
                              <v-text-field
                                ref="description"
                                v-model="productForm.description"
                                :rules="[]"
                                label="Descripción"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';
import { taxes } from '../helpers/taxHelper';
import { types } from '../helpers/productHelper';

export default {
  name: 'OpenBillingProductForm',
  components: {},
  props: ['showModal', 'productId'],
  data() {
    return {
      tabs: ['Datos'],
      selectedTab: 0,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
      },
      productForm: {
        id: null,
        clavedat: null,
        invoice_type: ['Venta'],
        openbilling_profile_id: null,
        name: null,
        price: null,
        type: 'Producto',
        tax: '21',
        description: null,
      },
    };
  },
  mounted() {
    if (this.productId) {
      this.getProductData();
    }
  },
  computed: {
    show() {
      return this.showModal;
    },
    toolbarTitle() {
      return this.productId ? 'EDITAR PRODUCTO' : 'NUEVO PRODUCTO';
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    taxes() {
      return taxes;
    },
    types() {
      return types;
    },
  },
  methods: {
    createProduct() {
      let validatedFormFields = [];
      this.$refs.productForm.validate();
      Object.keys(this.productForm).forEach(f => {
        console.log(f);
        if (this.$refs[f]) {
          const validated = this.$refs[f].validate(true);
          validatedFormFields.push(validated);
        }
      });

      if (validatedFormFields.every(validated => validated === true)) {
        this.productForm.clavedat = this.clavedat;
        this.productForm.openbilling_profile_id = this.billingProfileId;

        apiCtrl
          .post(`/openbilling/${this.clavedat}/products/create`, this.productForm)
          .then(res => {
            this.$emit('on-saved-product', res.data.data);
          })
          .catch(err => console.log(err));
      }
    },
    updateProduct() {
      this.productForm.clavedat = this.clavedat;
      this.productForm.openbilling_profile_id = this.billingProfileId;

      apiCtrl
        .post(`/openbilling/${this.clavedat}/products/update/${this.productId}`, this.productForm)
        .then(res => {
          this.$emit('on-saved-product', res.data.data);
        })
        .catch(err => console.log(err));
    },
    onClickSaveProduct() {
      if (this.productId) {
        this.updateProduct();
      } else {
        this.createProduct();
      }
    },
    onClickCloseModal() {
      this.$emit('click-on-close');
    },
    getProductData() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/products/show/${this.productId}`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.productForm).forEach(key => {
            this.productForm[key] = data[key];
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    resetProductForm() {
      this.productForm = {
        id: null,
        clavedat: null,
        invoice_type: [],
        openbilling_profile_id: null,
        name: null,
        price: null,
        type: 'Producto',
        tax: '21',
        description: null,
      };
    },
  },
  watch: {
    productId: function() {
      if (this.productId) {
        this.getProductData();
      }
    },
  },
};
</script>

<style scoped></style>
